// extracted by mini-css-extract-plugin
export default {"forumPanel":"m7vNYGEjyfBggYbT1KIE"};